<template>
  <div class="center-warp">
    <div class="inner ">
      <div class="count-card">
        <div class="count-card-top d-flex-between">
          <div class="count-card-top-title">订单管理</div>
        </div>
        <div class="count-card-bottom d-flex-between">
          <div class="count-card-item size3-1" @click="goDataPage(0)">
            <div class="count-card-item-name">待确认</div>
            <div class="count-card-item-num">{{ tData.pendingConfirmOrderCount }}</div>
          </div>
          <div class="count-card-item size3-1" @click="goDataPage(1)">
            <div class="count-card-item-name">待发货</div>
            <div class="count-card-item-num">{{ tData.pendingShipmentOrderCount }}</div>
          </div>
          <div class="count-card-item size3-1" @click="goDataPage(2)">
            <div class="count-card-item-name">已发货</div>
            <div class="count-card-item-num">{{ tData.shippedOrderCount }}</div>
          </div>
        </div>
      </div>
      <div class="count-card">
        <div class="count-card-top d-flex-between">
          <div class="count-card-top-title">已完成的定制订单数量</div>
          <div class="d-flex">
            <el-date-picker
              class="home-year"
              v-model="chatLineParams.year"
              :picker-options="pickerBornOption"
              type="year"
              format="yyyy"
              value-format="yyyy"
              @change="yearChange"
              placeholder="选择年">
            </el-date-picker>
            <div class="month-toggle">
              <i class="iconfont icon-shangyiye" @click="monthChange('del')"></i>
              <div>{{ chatLineParams.month }}月</div>
              <i class="iconfont icon-xiayiye" @click="monthChange('add')"></i>
            </div>
          </div>
        </div>
        <div class="count-card-bottom">
          <div class="chart" id="chart1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Line} from '@antv/g2plot';
import {GetSupplierData, GetSupplierChatLineData} from "@/http/home";

export default {
  name: "TechnicianHome",
  data() {
    return {
      tData: {},
      chatLineParams: {
        year: null,
        month: null,
      },
      chatLineData: [],
      line: null,
      timer: null,
      pickerBornOption:{
        disabledDate(time){
          return time.getTime() > new Date().getTime()
        }
      }
    }
  },
  created() {
    this.getHomeData();
    this.chatLineParams.year =  new Date().getFullYear().toString();
    this.chatLineParams.month = new Date().getMonth() + 1;
    this.getChatLineData();
  },
  methods: {
    goDataPage(type){
      this.$router.push({
        path:'/bill_center',
        query:{
          type:type
        }
      })
    },
    getHomeData() {
      GetSupplierData().then(res => {
        this.tData = res.data;
      })
    },
    getChatLineData() {
      GetSupplierChatLineData(this.chatLineParams).then(res => {
        this.chatLineData = res.data;
        this.line = this.initChart('chart1', this.chatLineData);
      })
    },
    yearChange(){
      GetSupplierChatLineData(this.chatLineParams).then(res => {
        this.line.changeData(res.data)
      })
    },
    monthChange(type) {
      if (type == 'del' && this.chatLineParams.month > 1) this.chatLineParams.month -= 1
      if (type == 'add' && this.chatLineParams.month < 12) this.chatLineParams.month += 1
      // 在每次点击时清除之前的计时器
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        GetSupplierChatLineData(this.chatLineParams).then(res => {
          this.line.changeData(res.data)
        })
      }, 200);
    },
    initChart(containerId, data) {
      var option = {
        xField: 'date',
        yField: 'value',
        padding: 'auto',
        xAxis: {
          tickCount: 11,
          label: {
            formatter: (v) => {
              return v.substring(5, 20);
            },
            style: {
              fill: '#333333',
            },
          }
        },
        yAxis: {
          tickCount: 11,
          label: {
            style: {
              fill: '#333333',
            },
          },
          grid: {
            line: {
              style: {
                lineWidth: 1,
                lineDash: [6, 7],
              }
            }
          }
        },
        lineStyle: {
          stroke: '#FED400',
        },
        tooltip: {
          showMarkers: true,
          size: 5,
          formatter: (v) => {
            return { name: '完成订单', value: v.value };
          },
        },
        theme: {
          defaultColor: '#FED400'
        }
      }
      const line = new Line(containerId, option);
      line.changeData(data)

      line.render();
      return line;
    }
  }
}
</script>

<style scoped src="../../assets/css/sales_home.css">
</style>

<style>
.home-year{
  height: 31px;
  margin-right: 10px;
}
.home-year input{
  height: 31px;
  border: 1px solid #E5E5E5;
}
.home-year .el-input__icon{
  line-height: 29px;
}
</style>
